import { useEffect, useState } from "react";
import axios from "axios";

export interface PageContentEntry {
  key: string;
  label: string;
  title: string;
  overview: string;
}

// Module-level cache so all steps share one fetch
let cache: PageContentEntry[] | null = null;
let promise: Promise<PageContentEntry[]> | null = null;

async function fetchContent(): Promise<PageContentEntry[]> {
  if (!promise) {
    promise = axios
      .get((process.env.REACT_APP_HOST_URL || "") + "/api/page-content")
      .then((r) => {
        cache = r.data?.content || [];
        return cache!;
      })
      .catch(() => {
        promise = null; // allow retry on error
        return [];
      });
  }
  return promise;
}

export function usePageContent(stepKey: string): { title: string; overview: string } {
  const [entry, setEntry] = useState<PageContentEntry | null>(null);

  useEffect(() => {
    if (cache) {
      setEntry(cache.find((e) => e.key === stepKey) ?? null);
    } else {
      fetchContent().then((content) => {
        setEntry(content.find((e) => e.key === stepKey) ?? null);
      });
    }
  }, [stepKey]);

  return { title: entry?.title ?? "", overview: entry?.overview ?? "" };
}
